import React, { useState, useEffect } from "react";

/*Import API helpers */
import { fetchGET } from "../apiHelper";
import { koristniLinki } from "../listOfApi";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Homepage = ({ role }) => {
  const [linki, setLinki] = useState([]);

  useEffect(() => {
    fetchGET(koristniLinki).then((data) => {
      if (data !== 0) {
        setLinki(data);
      }
    });
  }, []);

  return (
    <Container fluid>
      <Row>
        <Col className="main-header font-weight-bold">Vstopna stran</Col>
      </Row>
      <Row>
        <Col className="header-divider">
          <hr />
        </Col>
      </Row>
      <Row>
        <Col style={{ margin: "10px 0" }}>
          <h4>Koristne povezave</h4>
        </Col>
      </Row>
      <Row>
        {linki?.map((link, linkIndex) => {
          return (
            <Row style={{ marginBottom: "1em", lineHeight: "1.2" }}>
              <Col>
                <div style={{ fontWeight: "bold" }}>{link.naziv}</div>
                <a
                  href={link.link}
                  target="_blank"
                  style={{ width: "max-content" }}
                >
                  {link.link}
                </a>
              </Col>
            </Row>
          );
        })}
      </Row>
    </Container>
  );
};

export default Homepage;
